module.exports = __webpack_public_path__ + "static/media/bfile-ira.24fac37f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-ira.svg
// module id = 1007
// module chunks = 0